module.exports = __webpack_public_path__ + "img/content10.7bf09775.png";